import React from 'react';
import css from './BlogSkeleton.module.css';

const BlogSkeleton = () => {
  return (
    <div className={css.blogSkeleton}>
      {/* Blog Header */}
      <div className={css.blogHeader}>
        <div className={css.skeletonCategory}></div>
        <div className={css.skeletonTitle}></div>
        <div className={css.skeletonMeta}>
          <div className={css.skeletonAuthor}></div>
          <div className={css.skeletonDate}></div>
          <div className={css.skeletonReadingTime}></div>
        </div>
      </div>

      {/* Blog Image */}
      <div className={css.skeletonImage}></div>

      {/* Blog Content */}
      <div className={css.blogContent}>
        {/* Excerpt */}
        <div className={css.skeletonExcerpt}></div>
        
        {/* Content Sections */}
        <div className={css.contentSection}>
          <div className={css.skeletonSubtitle}></div>
          <div className={css.skeletonParagraph}></div>
          <div className={css.skeletonParagraph}></div>
          <div className={css.skeletonParagraphShort}></div>
        </div>
        
        <div className={css.contentSection}>
          <div className={css.skeletonSubtitle}></div>
          <div className={css.skeletonParagraph}></div>
          <div className={css.skeletonParagraph}></div>
        </div>
        
        <div className={css.contentSection}>
          <div className={css.skeletonSubtitle}></div>
          <div className={css.skeletonParagraph}></div>
          <div className={css.skeletonParagraphShort}></div>
        </div>
      </div>

      {/* Author Section */}
      <div className={css.authorSection}>
        <div className={css.skeletonAuthorAvatar}></div>
        <div className={css.skeletonAuthorInfo}>
          <div className={css.skeletonAuthorName}></div>
          <div className={css.skeletonAuthorBio}></div>
        </div>
      </div>

      {/* Share Section */}
      <div className={css.shareSection}>
        <div className={css.skeletonShareTitle}></div>
        <div className={css.skeletonShareButtons}>
          <div className={css.skeletonShareButton}></div>
          <div className={css.skeletonShareButton}></div>
          <div className={css.skeletonShareButton}></div>
          <div className={css.skeletonShareButton}></div>
        </div>
      </div>
    </div>
  );
};

export default BlogSkeleton;
